import { createSelector } from 'reselect';

const getBaseColor = (state) => state?.config.baseColor;
const getOutColor = (state) => state?.config.outColor;

export const getBaseOutColors = createSelector(
    [getBaseColor, getOutColor],
    (baseColor, outColor) => {
        return { baseColor, outColor };
    }
);
